import { client } from "@common/client/client.gen"

type AccessClient = "web" | "extension" | "desktop"
type DeviceType = "desktop" | "phone" | "tablet"

function deviceType(): DeviceType {
  const userAgent = navigator.userAgent
  const touchMac = /Macintosh/.test(userAgent) && navigator.maxTouchPoints > 1
  const androidTablet = /Android/.test(userAgent) && !/Mobile/.test(userAgent)
  if (/iPad|Tablet/i.test(userAgent) || touchMac || androidTablet) {
    return "tablet"
  }
  if (/Mobi|iPhone|Android/i.test(userAgent)) return "phone"
  return "desktop"
}

export function installClientHeaders(accessClient: AccessClient) {
  const device = deviceType()
  client.instance.interceptors.request.use((config) => {
    config.headers.set("X-Fleetcraft-Client", accessClient)
    config.headers.set("X-Fleetcraft-Device", device)
    return config
  })
}
